module.exports = __webpack_public_path__ + "static/media/img1-3.32e0d70f.png";